import PropTypes from 'prop-types'
import React from 'react'
import BRAND from '../../config/branding'

const LoaderBox = ({ loader, noData, style }) => (
  <>
    {loader && (
      <div className="loading-content xv-loader" style={style}>
        <img src={BRAND.icon} alt={BRAND.productName} className="xv-loader-icon" />
        <h1>{loader === true ? 'Loading…' : loader}</h1>
      </div>
    )}
    {!loader && noData && (
      <div className="loading-content xv-loader" style={style}>
        <img src={BRAND.icon} alt={BRAND.productName} className="xv-loader-icon" />
        <h1>{noData === true ? 'No data found' : noData}</h1>
      </div>
    )}
  </>
)

LoaderBox.propTypes = {
  loader: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  noData: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  style: PropTypes.object
}

export default LoaderBox
